/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { Modal, Button } from "react-bootstrap";
import * as Yup from "yup";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import clsx from "clsx";
import { toast } from "react-toastify";
import {
  getCategory,
  getCuisine,
  listDishes,
  getType,
  updateDish,
  createCategory,
  checkDuplicateCategory,
} from "../core/_requests";

import { useLocation, useNavigate } from "react-router-dom";
import { UUID } from "crypto";

import { ProfileDetails } from "../../settings/core/_requests";
import Pagination from "../../../component/Pagination";

import CategoryModal from "../../category/files/CategoryModal";
import { PlusCircle } from "lucide-react";
import SearchInput from "../../../component/core/Searchinput";
interface Dish {
  primaryId: any;
  dishImage: string;
  name: string;
  cuisine: any;
  dishType: any;
  category: any;
  type: any;
  tags: string;
  averageReviews:string;
  preparationTime: any;
  enableDisableStatus: boolean;
  addons: Addon[];
  dishvariants: DishVariant[];
   dishreviews?: DishReview[];
}
interface DishReview {
  id: number;
  reviews: number;
  description: string;
  user: {
    name: string;
  };
}

interface Addon {
  id: number;
  name: string;
  quantity: number;
  price: number;
}

interface DishVariant {
  id: number;
  unit: number;
  measurementId: number;
  price: number;
  discount: number;
  finalPrice: number;
}
interface Cuisine {
  uuid: UUID;
  name: string;
}
interface Type {
  uuid: UUID;
  name: string;
}
interface Category {
  uuid: UUID;
  name: string;
}

interface CategoryAdd {
  chefId: string | undefined;
  name: string;
  description: string;
  Image: any;
  formImage: any;
  createdBy: any;
  updatedBy: any;
}

const initialValues: CategoryAdd = {
  chefId: "",
  name: "",
  description: "",
  Image: "",
  formImage: "",
  createdBy: "",
  updatedBy: "",
};

const ListDishes = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [listDish, setListDish] = useState<Dish[]>([]);
  const [cuisine, setCuisine] = useState<Cuisine[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  
  const [type, setType] = useState<Type[]>([]);
  const [cuisineId, setCuisineId] = useState("");
  const [dish_type, setDishType] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [search, setSearch] = useState("");
  const [selectedTypes, setSelectedTypes] = useState<Type[]>([]);
  const [showModal, setShowModal] = useState(false);
  const chefId = currentUser?.uuid;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  const [dish_count, setDishCount] = useState<any>();
  const [data, setData] = useState<CategoryAdd>(initialValues);
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllTags, setShowAllTags] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [isDishCountLoaded, setIsDishCountLoaded] = useState(false);
const [chefPlanAccess, setChefPlanAccess] = useState<any>(null);

  const { dish, avgRating } = location.state || {};
  useEffect(() => {
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);
useEffect(() => {
  if (!chefId) return;

  const fetchProfile = async () => {
    try {
      const res = await ProfileDetails(chefId);
    const chefPlanAccess =
  res.data?.chef_plan_subscriptions?.[0]?.plan?.chef_plan_accesses?.[0];

setChefPlanAccess(chefPlanAccess);
setDishCount(chefPlanAccess?.dish_count ?? 0);
setIsDishCountLoaded(true);
    } catch (error) {
      console.error("Error fetching profile details:", error);
      setDishCount(10); // Default to 10 on error
      setIsDishCountLoaded(true);
    }
  };

  fetchProfile();
}, [chefId]);

  const handleModal = () => {
    setShowModal((prev) => !prev);
  };

  const AddDish = () => {
  if (!isDishCountLoaded) {
    toast.error("Dish count is still loading. Please wait.");
    return;
  }

  if (listDish.length < dish_count) {
    navigate("/dish/add");
  } else {
    toast.info("You have reached the maximum dishes allowed for your plan.");
    navigate("/access");
  }
};

const BulkAddDish = () => {
  if (!isDishCountLoaded) {
    toast.error("Loading access… please wait");
    return;
  }

  // If plan does not allow bulk dishes
  const hasBulkAccess =
    chefPlanAccess?.is_bulk_dish === true || false;

  if (!hasBulkAccess) {
    toast.warning("Your plan does not allow bulk dishes");
    navigate("/access");
    return;
  }

  // If user reached bulk limit
  if (dish_count <= 0) {
    toast.info("Bulk dish limit reached — Upgrade plan");
    navigate("/access?reason=bulk-limit");
    return;
  }

  // All good → Continue to Bulk Add page
  navigate("/dish/bulk-add");
};

  // useEffect to fetch dishes whenever filters or search term change
  useEffect(() => {
    const fetchDishes = async () => {
      setLoading(true);
      try {
        const res = await listDishes(chefId, filterData);
                setListDish(res?.data);
      } catch (error) {
        console.error("Error fetching dishes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDishes();
  }, [search, cuisineId, dish_type, categoryId, selectedTypes, chefId]);
  // useEffect to set the search term from URL (or local storage if needed)


  const toggleShowAllTags = (index: number) => {
    setShowAllTags((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const filterData = {
    search: dataSearch,
    cuisineId: cuisineId,
    dish_type: dish_type,
    categoryId: categoryId,
    typeId: selectedTypes,
  };
 
  useEffect(() => {
    getCuisine()
      .then((res) => {
        setCuisine(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching cuisine:", error);
      });

    getType()
      .then((res) => {
        setType(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching type:", error);
      });

  }, [search]);

  // Second useEffect to fetch category data
  useEffect(() => {
    getCategory(!chefId)
      .then((res) => {
        //         setCategory(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, [chefId]);

  const handleCheckboxChange = (value: any) => {
    setSelectedTypes((prevSelectedTypes) =>
      prevSelectedTypes.includes(value)
        ? prevSelectedTypes.filter((type) => type !== value)
        : [...prevSelectedTypes, value]
    );
  };

  const clickApply = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    //pagination
    setCurrentPage(1);
    const data = {
      search: search,
      typeId: selectedTypes,
      categoryId: categoryId,
      dish_type: dish_type,
      cuisineId: cuisineId,
    };

    try {
      const res = await listDishes(chefId, data);
      setListDish(res?.data); // Update the listDish state with the new data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching dishes:", error);
      setLoading(false);
    }
  };

  const clickCancel = () => {
    navigate("/dish");
  };

  const viewDish = (primaryId: string) => {
    navigate("/dish/view/" + primaryId);
  };

  const editDish = (primaryId: string) => {
    navigate("/dish/edit/" + primaryId);
  };
  const deleteDish = (primaryId: string) => {
    navigate("/dish/delete/" + primaryId);
  };
  const listDishUpdate = async () => {
    try {
      const res = await listDishes(chefId, data);
      //       setListDish(res?.data); // Update the listDish state with the new data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching dishes:", error);
      setLoading(false);
    }
  };

  const handleEnableDisable = async (id: string, status: boolean) => {
  const enableDisable = !status; // Toggle status

  try {
    const res = await updateDish(id, { enableDisableStatus: enableDisable });
    toast.success(res?.message, { autoClose: 5000 });

    // ✅ Update the state directly instead of refetching
    setListDish((prevList) =>
      prevList.map((dish) =>
        dish.primaryId === id
          ? { ...dish, enableDisableStatus: enableDisable }
          : dish
      )
    );
  } catch (error) {
    console.error("Error updating dish:", error);
    toast.error("Failed to update dish availability");
  }
};

  //pagination

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listDish.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listDish.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }


  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
              <div className="title mb-3">
                <h3 className="mb-0">Dishes ({listDish?.length})</h3>
              </div>
              <div className="col-12 title-btm">
              <SearchInput
                 value={search}
                     onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                  onKeyUp={clickApply}
                  />

                <div className="d-flex justify-content-end title-btm-btn-sec">
                  <button
                    className="btn btn-primary btn-ico rounded-5 ms-auto me-2"
                    onClick={handleModal}
                  >
                    <i className="material-symbols-outlined">add_circle</i>{" "}
                    Category
                  </button>

              

                  <div className="dropdown ms-auto me-2">
                    <button
                      className="btn btn-primary btn-ico rounded-5 dropdown-toggle"
                      type="button"
                      id="dishActionsDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      disabled={!isDishCountLoaded}

                    >
                      Add
                    </button>
                    <ul
                      className="dropdown-menu shadow"
                      aria-labelledby="dishActionsDropdown"
                    >
                      <li>
                        <button
                          className="dropdown-item d-flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 text-sm"
                          type="button"
                          onClick={AddDish}
                          disabled={!isDishCountLoaded}
                        >
                          <i className="material-symbols-outlined fs-5 text-blue-600">add_circle</i>
                          Add Dish
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 text-sm"
                          type="button"
                          onClick={BulkAddDish}
                        >
                          <i className="material-symbols-outlined fs-5 text-green-600">upload</i>
                          Bulk Add Dish
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="filter-sec mt-4">
                <form
                  noValidate
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="row gx-3">
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label">Cuisine</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setCuisineId(e.target.value)}
                      >
                        <option value="">All</option>
                        {cuisine.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label">Category</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setCategoryId(e.target.value)}
                      >
                        <option value="">All</option>
                        {category.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label">Type</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setDishType(e.target.value)} // Set dish_type state
                      >
                        <option value="1">Regular</option>
                        <option value="2">Bulk</option>
                      </select>
                    </div>

                    <div className="col-xl-4 col-lg-6 d-flex align-items-center justify-content-lg-end justify-content-between pt-4 filter-btn-sec">
                      <button
                        className="btn btn-cancel rounded-5 small me-2 mt-1"
                        onClick={clickCancel}
                      >
                        Clear
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary rounded-5 small mt-1 clickedbutton"
                        onClick={clickApply}
                      >
                        Apply
                      </button>
                    </div>
                    <div className="col-xl-4 col-lg-6 mt-lg-2 mt-xl-0 mt-2">
                      <label className="form-label">Type</label>
                      {type.map((item: any, i) => {
                        return (
                          <div
                            className="form-check form-check-inline me-2 mt-2"
                            key={i}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`inlineCheckbox${i + 1}`}
                              value={item?.uuid}
                              checked={selectedTypes.includes(item?.uuid)}
                              onChange={() => handleCheckboxChange(item?.uuid)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`inlineCheckbox${i + 1}`}
                            >
                              {item?.name}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </form>
              </div>

              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Type</th>
                      <th> Name</th>
                      <th>Cuisine-Category</th>
                      <th>Type</th>
                      <th>Tags</th>
                      <th>Unit - Price ($)</th>
                      <th>Rating</th>
                      <th>Preparation Time</th>
                      <th>Available</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, i) => {
                        const tags =
                          item?.tags?.split(",").map((tag) => tag.trim()) || []; // Split and trim tags
                        const displayTags = showAllTags[i]
                          ? tags
                          : tags.slice(0, 3); // Show all or first 3 tags
                        const excessCount =
                          tags.length > 3 ? tags.length - 3 : 0; // Calculate excess count

                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td
                              className={
                                item?.dishType === 2
                                  ? "text-success fs-bold"
                                  : ""
                              }
                            >
                              {item?.dishType === 1
                                ? "Regular"
                                : item?.dishType === 2
                                  ? "Bulk"
                                  : ""}
                            </td>

                            <td>
                              <div className="dish">
                                <div className="thumbnail">
                                  <img src={item?.dishImage} alt="Dish Name" />
                                </div>
                                <p className="ms-2 mb-0">{item?.name}</p>
                              </div>
                            </td>
                            <td>
                              <p className="mb-0">
                                {item?.cuisine?.name} - {item?.category?.name}
                              </p>
                            </td>
                            <td>
                              <p className="mb-0 type">
                                <img src={item?.type?.iconUrl} alt="Veg" />{" "}
                                {item?.type?.name}
                              </p>
                            </td>
                            <td>
                              {displayTags.map((tag, index) => (
                                <span
                                  key={index}
                                  className="badge tag me-1 mt-1"
                                >
                                  {tag}
                                </span>
                              ))}
                              {excessCount > 0 && !showAllTags[i] && (
                                <span
                                  className="count cursorPointer"
                                  onClick={() => toggleShowAllTags(i)}
                                >
                                  +{excessCount}
                                </span>
                              )}
                            </td>
                            <td>
                              {item.dishvariants?.length > 0 && (
                                <div>
                                  <p>
                                    {item.dishvariants[0]?.unit} - $
                                    {item.dishvariants[0]?.finalPrice.toFixed(
                                      2
                                    )}
                                  </p>
                                </div>
                              )}
                            </td>
  <td>
  <span className="rating">
    <img src="/assets/images/star.svg" alt="Rating" />

    {item.dishreviews?.length
      ? (
          item.dishreviews.reduce((sum, r) => sum + r.reviews, 0) /
          item.dishreviews.length
        ).toFixed(1)
      : 0}
  </span>
</td>

                            <td>
                              <p className="mb-0">{item?.preparationTime}</p>
                            </td>
                            <td>
                              <div className="form-check form-switch">
                              <input
  className="form-check-input cursorPointer"
  type="checkbox"
  role="switch"
  id={`flexSwitchCheckDefault-${item.primaryId}`} // unique id
  checked={item?.enableDisableStatus}
  onChange={() =>
    handleEnableDisable(item?.primaryId, item?.enableDisableStatus)
  }
/>

                                <label className="yes">Yes</label>
                                <label className="no">No</label>
                              </div>
                            </td>
                            <td>
                              <div className="action-item">
                                <a onClick={() => editDish(item?.primaryId)}>
                                  <span className="material-symbols-outlined">
                                    edit
                                  </span>
                                </a>
                                <a
                                  className="danger cursorPointer"
                                  onClick={() => deleteDish(item?.primaryId)}
                                >
                                  <span className="material-symbols-outlined">
                                    delete
                                  </span>
                                </a>
                                <a onClick={() => viewDish(item?.primaryId)}>
                                  <span className="material-symbols-outlined cursorPointer">
                                    info
                                  </span>
                                </a>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : loading ? (
                      <tr>
                        <td colSpan={11} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={11} className="text-center">
                         No Dishes Found – Time to Add Your Signature Recipes!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                data={listDish}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>

            {/* Modal for Add Category */}
            <CategoryModal showModal={showModal} handleModal={handleModal} />
            {/* Modal for Add Category */}
          </section>
        </div>
      </section>
    </>
  );
};

export default ListDishes;